import { data } from '../../svg/Partner/data';
import { makeIcon } from '../makeIcon';

export const Partner = makeIcon(data, 'partner', 'Partner');

export default Partner;
